var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip:top",value:(_vm.descriptionText),expression:"descriptionText",arg:"top"}],staticClass:"signatures-progress"},_vm._l((_vm.qtyElements),function(index){return _c('div',{key:index,staticClass:"progress-unit",class:{ active: index <= _vm.dotsFilled }})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }